namespace app.navigation {
    'use strict';

    import IScope = angular.IScope;
    
    export class NavigationController {
        
        public folded: boolean;
        public msScrollOptions;
    
        /** @ngInject **/
        constructor (private $scope: IScope) {
            
            this.folded = true;
            this.msScrollOptions = {
                suppressScrollX: true
            };
            
            // Close the mobile menu on $stateChangeSuccess
            $scope.$on('$stateChangeSuccess', () => {
                angular.element('body').removeClass('ms-navigation-horizontal-mobile-menu-active');
            });
        }
        
        public toggleMsNavigationFolded() {
            this.folded = !this.folded;
        }
    }
    
    angular
        .module('app.navigation')
        .controller('app.NavigationController', NavigationController);
}